<!-- TODO:
  Component needs default filter To show only Related to 
  bp_reference QUnits. 
  Ex. TAB related QUnits 'Actions' should only show 'ACCIONUNIVERSALDEFAULT'
-->
<template>
  <v-container fluid class="qmkey-related-inline-table">
    <v-data-table
      v-model="selected"
      :headers="headersCustom"
      :items="items"
      item-key="value"
      dense
      sortBy="readable_type"
      class="qmkey-related-inline-table"
      @click:row="goToExplorerItem"
    >
      <!-- Header -->
      <!-- Type column -->
      <template v-slot:[`header.readable_type`]="{ header }">

          {{ header.text }}
        <div style="float:right">
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-x
            left
            fixed
            max-width="290"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                icon
                small
              >
                <v-icon small 
                  :color="activeFilters[header.value] && activeFilters[header.value].length < filters[header.value].length ? '#7a5bc3' : '#85a43c'"
                  >
                      mdi-filter-variant
                </v-icon>
              </v-btn>
            </template>              
              <v-list 
                flat
                dense
                class="qmkey-menu-filter-contents pa-0">
                <v-list-item-group 
                  multiple
                  v-model="activeFilters[header.value]"
                  class="py-2"
                >
                  <template 
                    v-for="(item) in filters[header.value]"
                  >
                    <v-list-item
                      :key="`${item}`"
                      :value="item"
                    >
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            dense
                            color="#85a43c"
                          >
                          </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content> 
                          <v-list-item-title v-text="item">
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-btn
                      text
                      block 
                      @click="toggleAll(header.value)" 
                      color="success">
                        Toggle all
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      text
                      block
                      @click="clearAll(header.value)"
                      color="warning"
                    >
                      Clear all
                    </v-btn>
                  </v-col>
                </v-row> 
                
              </v-list>       
          </v-menu>
        </div>          
      </template>
      <!-- Body -->
      <!-- Actions -->
      <template v-slot:[`item.action`]="{ item }">
        <!-- Transitions -->
        <v-menu
          open-on-hover
          bottom
          left
          offset-x
          content-class="qmkey-explorer-table-menu-contents"
          v-model="menu_models[item.value]"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
        </template>
          <v-list dense>
            <v-list-item
              v-for="transition in getQUnitTransitionCandidates(item)"
              :key="transition.id"
              @click.stop="transitionForm(item, transition)"
            >
              <v-list-item-title>{{ transition.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    
    <!-- Modal dialog -->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      @close-dialog="toggle_dialog"
      @submit="process_form"
    >
    </modal-dialog-form>
    <!--  /Modal dialog -->   
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'
import ModalDialogForm from './ModalDialog'

export default {
  components: { ModalDialogForm },
  name: 'InlineBoxRelated',
  props: {
    current_qunit: Object,
    props: Object
  },
  data() {
    return {
      options: {
        sortBy: 'readable_type'
      },
      selected: [],
      filters: {
        title: [],
        current_workflow_responsible: [],
        current_workflow_limit: [],
        current_workflow_state: [],
        readable_type: [],
      },
      activeFilters: {},
      transitions_candidates: {},
      child_qunit: {},
      child_qunit_transition: {},
      show_transition: false,
      loading: false,
      valid: false,
      menu_model: '',
      menu_models: {},
      // FORM
      fields_to_collect: [],
      // show_transitions: true,
      current_transition: {},
      form_error_message: '',
      jsdata: '',
      edjsdata: '',
      business_process_name: '',
      disableTransitionModalButtons: false,
      addUnitBussinessProcess: '',
      addUnitParentProcess: '',
      alert: '',
      showModalDialog: false,
      modal_title:'',
      submit_button_caption: '',
    }
  },
  watch: {
    fields_to_collect(){
      // This is to inject javascript when form is loaded
      this.$nextTick(() => {
        if (this.jsdata) {
          var jsscript = document.createElement('script')
          jsscript.innerText = this.jsdata
          document.head.appendChild(jsscript)
        }
      })
    },
  },
  computed: {
    ...mapState([
      'sitePath',
      'explorer_sort_by',
      'explorer_sort_desc',
    ]),

    headersCustom() {
      return [
        { 
          text: 'Title',
          value: 'title',
        },
        { 
          text: 'Responsible',
          value: 'current_workflow_responsible' 
        },
        { 
          value: 'current_workflow_limit', 
          text: 'Limit' 
        },
        { 
          value: 'current_workflow_state',
          text: 'State' },
        { 
          value: 'readable_type',
          text: 'Type',
          filter: this.typesFilter
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        },
      ];
    },

    items(){
      if (this.props.filter){
        console.log("props", this.props.filter)
        let x = this.current_qunit['relations'].filter(item => item.bp_reference === this.props.filter)
        return x
      }
      return this.current_qunit['relations']
    },
  },
  
  created () {
    this.initFilters()
  },
  
  methods: {
    ...mapActions(['EXPLORE_UNITS']),
    ...mapMutations([
      'SET_BUSINESS_PROCESS',
      'SET_CURRENT_UNIT',
      'SET_TABLE_SELECTED',
    ]),

    toggleAll (col) {
      this.activeFilters[col] = this.items.map((d) => { return d[col] }).filter(
        (value, index, self) => { return self.indexOf(value) === index }
      )
    },

    columnValueList(val) {
      return this.items.map(d => d[val])
    },

    initFilters() {
      var col = ''
      console.log(this.items)
      for (col in this.filters) {
        this.filters[col] = this.items.map((d) => { return d[col] }).filter(
            (value, index, self) => { return self.indexOf(value) === index }
          )
      }
      // TODO:
      // FIXME: hardcoded initial filter
      this.activeFilters = Object.assign({}, this.filters)
      console.log(
        'Warning: "Harcoded initial readable filter"' +
        'RelationsBox.initFilters() '        
      )
      this.activeFilters['bp_reference'] = ['ACCIONUNIVERSALDEFAULT']
    },    
    
    clearAll (col) {
      this.activeFilters[col] = []
    },
    
    typesFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (this.activeFilters.readable_type.length == 0) {
        return false
      }

      // Check if the current loop value (The readable_type value)
      // in current readable type selecteds.
      return this.activeFilters['readable_type'].includes(value)
    },    

    goToExplorerItem(row){
      if (row.bp_reference) {
         let bp_reference = encodeURIComponent(row.bp_reference)
         let pk = encodeURIComponent(row.value)
         let url = '/explorer?business_process=' + bp_reference + '&pk=' + pk
         this.SET_BUSINESS_PROCESS(bp_reference)
         this.$router.push(url)
      }
    },

    getQUnitTransitionCandidates(item){
      if  (!item.bp_reference) {
        return []
      }
      if (!this.transitions_candidates[item.value]){
        let pk = item.value
        QUnit.getTransitionCandidates(this.sitePath, pk)
          .then(data => {
            this.transitions_candidates[pk] = data
            return this.transitions_candidates[pk]
          })
          .catch(
            error =>
              (console.log(
                error.body || error.response.data)
              ),
          )
      }
      return this.transitions_candidates[item.value]
    },

    transitionForm(item, transition){
      this.child_qunit = item
      this.child_qunit_transition = transition
      this.show_transition = true
      this.performTransition(item, transition)
    },
    // FORM
    addUnit(business_process, parent_qunit_id) {
      // Collect data to creation form
      this.creation_form_error_message = ''
      parent_qunit_id = parent_qunit_id || ''
      if (!business_process) {
        business_process = this.current_business_process
      }
      if (business_process) {
        QUnit.getFieldsToCollectDuringCreation(
          this.sitePath, business_process, parent_qunit_id)
          .then(data => {
            this.fields_to_collect = data['fields']
            // this.creation_fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.addUnitBussinessProcess = business_process
            this.addUnitParentProcess = parent_qunit_id
            this.business_process_name = data['business_process_name']
            this.addModalDialog = true
            this.showModalDialog = true
            // TODO:Lang
            this.modal_title = 'Add new ' + this.business_process_name
            this.submit_button_caption = 'Add'
          })
          .catch(
            error =>
              (this.creation_form_error_message =
                error.body || error.response.data),
          )
      } else {
        this.creation_form_error_message = 'no business_process provided!'
        // this.showAddModalDialog = true
      } 
    },
    submitAddUnit(form_data) {
      let current_item_uid = this.current_unit['uid']
      this.$root.$loader.show()
      QUnit.createUnit(this.sitePath, form_data)
        .then(data => {
          this.selected = [data]
          if (this.addUnitBussinessProcess == this.current_business_process){
            current_item_uid = data.uid
          }
          this.EXPLORE_UNITS({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: this.processID,
            search_text: this.search,
            filters_form: this.filterFormData,
            filter_directory: this.filterDirectory,
            units_page: this.unitsPage,
            units_sort_by: this.explorer_sort_by,
            units_sort_desc: this.explorer_sort_desc,
            pk: current_item_uid,
          })
          this.toggle_dialog()
          this.$root.$loader.hide()
          this.$emit('form_submit', this.current_qunit)

        })
        .catch(error =>{
            (this.creation_form_error_message =
              error.body || error);
            this.disableAdddModalButtons=false
        })
    }, 
    performTransition(unit, transition) {
      this.SET_CURRENT_UNIT(unit)
      this.SET_TABLE_SELECTED([this.current_qunit])
      this.form_error_message = ''
      if (transition['related_business_process']) {
        this.addUnit(
          transition['related_business_process'],
          unit.value,
        )
      } else {
        QUnit.getFieldsToCollectDuringTransition(
          this.sitePath,
          unit['value'],
          transition['id'],
        )
          .then(data => {
            this.creation_fields_to_collect = []
            this.fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.current_transition = transition
            // this.$refs.transmodal.show()
            this.showModalDialog = true
            this.addModalDialog = false
            // TODO:Lang
            this.modal_title = this.current_transition.label
            this.submit_button_caption = 'Save'
          })
        .catch(
          error =>{
            (this.form_error_message = error.body || error.response.data);
        })
     }
    },
    submitTransition(form_data) {
      var new_items = []
      // form_data.append('transition_id', this.current_transition.id);
      let current_item_uid = this.child_qunit['value']
      this.$root.$loader.show()  
      QUnit.executeTransition(
        this.sitePath,
        current_item_uid,
        form_data,
      )
        .then(data => {
          this.toggle_dialog()
          this.$root.$loader.hide()
          for (var i=0; i<this.units.length;i++){
            var item = this.units[i]
            if (item.uid == current_item_uid){
                item = data                
                this.SET_TABLE_SELECTED([item])
            }
            new_items.push(item)
          }
          this.UPDATE_UNITS_TABLE({new_units:new_items})
        })
        .catch(
          error =>{
            (this.form_error_message = error.body || error.response.data);
        })
    },
    toggle_dialog() {
      this.addUnitBussinessProcess = ''
      this.addUnitParentProcess = ''
      this.fields_to_collect = []
      this.creation_fields_to_collect = []
      this.showModalDialog = false
      this.addModalDialog = null
    },
    process_form: function (form_data) {
      console.log('Explorer, form submit', form_data)
      form_data.append('business_process', this.addUnitBussinessProcess)
      form_data.append('parent_process', this.addUnitParentProcess)
      if (this.addModalDialog) {
        console.log('Perform add QUnit')
        this.submitAddUnit(form_data)        
      }else{
        console.log('Perform Transition')
        form_data.append('transition_id', this.current_transition.id)
        this.submitTransition(form_data)
      }

    },
  }
}
</script>


<style lang="scss">
    @import "@/sass/explorer.scss";
</style>
